// extracted by mini-css-extract-plugin
export default {"address-picker__manual-address":"address-picker_address-picker__manual-address__77DAS","address-picker__add-icon":"address-picker_address-picker__add-icon__E6XF-"};